import React, { useEffect, useState } from 'react';

const SearchFilter = (props) => {
    const [innerText, setInnerText] = useState(props?.value ?? '');
    const [outerText, setOuterText] = useState(props?.value ?? '');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [focused, setFocused] = useState(false);
    const [showFilterMessage, setShowFilterMessage] = useState(!!props.value);

    useEffect(() => {
        setInnerText(props?.value ?? '');
        setOuterText(props?.value ?? '');
        if (props?.value) {
            setShowFilterMessage(true);
        }
    }, [props.value]);

    useEffect(() => {
        if (props?.isLoading) {
            return;
        }

        if (innerText !== outerText) {
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }
            const timeout = setTimeout(
                () => {
                    setOuterText(innerText);
                    props.callBack(innerText);
                    setShowFilterMessage(true);
                },
                innerText.length === 0 ? 400 : 800
            );
            setDebounceTimeout(timeout);
        }
    }, [innerText]);

    const clearInput = () => {
        if (props.disabled) return;

        setInnerText('');
        setOuterText('');
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        props.callBack('');
        setShowFilterMessage(false);
    };

    return (
        <div className='d-flex'>
            {showFilterMessage && innerText && (
                <div
                    className='font-weight-bold text-nowrap'
                    style={{
                        color: '#007dbc',
                        lineHeight: '32px',
                        paddingRight: '10px',
                    }}
                >
                    Clear the filter to see all the documents
                </div>
            )}
            <div className='filter d-flex' style={{ position: 'relative' }}>
                <input
                    {...props.inputProps}
                    style={{
                        ...props.style,
                        border: focused
                            ? '1px solid black'
                            : innerText
                            ? '1px solid #007DBC'
                            : '',
                    }}
                    disabled={props.disabled}
                    type='text'
                    placeholder={
                        props.placeholder?.length > 0
                            ? props.placeholder
                            : 'Filter'
                    }
                    className='form-control active patient-autoComplete form-control'
                    value={innerText}
                    onChange={(event) => {
                        setInnerText(event.target.value);
                        setShowFilterMessage(false);
                    }}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                />
                {innerText && (
                    <i
                        className='fa-regular fa-xmark'
                        style={{
                            cursor: props.disabled ? 'not-allowed' : 'pointer',
                        }}
                        onClick={clearInput}
                    />
                )}
                {!innerText && <i className='fa-regular fa-magnifying-glass' />}
            </div>
        </div>
    );
};

/**
 * @property _value_ : string | callBack: function | placeholder : string | style : input style props
 */
export default React.memo(SearchFilter);
